import React, { useState } from 'react'

import { Button, Modal } from 'components'
import HelpDialog from 'components/ManualAnalysisList/HelpDialog'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

export default function HelpDialogButton() {
  const [helpModalOpen, setHelpModalOpen] = useState(false)

  return (
  <React.Fragment>
    <span>
      <Button onClick={() => setHelpModalOpen(true)} startIcon={<HelpOutlineIcon size={25}/>} >
        Ajuda
      </Button>
    </span>
    <Modal
      open={helpModalOpen}
      onClose={() => setHelpModalOpen(false)}
      title="Ajuda"
    >
      <HelpDialog />
    </Modal>
  </React.Fragment>
  )
}
